import {
  AssetReportHeaderLabelsContainer,
  AssetReportHeaderOperation,
  AssetReportHeaderStyle,
  AssetReportHeaderTitle,
  AssetReportHeaderTypology,
} from './header.styles';
import { ReactComponent as AssetLogo } from '../../../assets/images/assetLogo.svg';
import { useIntl } from 'react-intl';
import { ReportDataResponse } from '../../../types/reportData.interface';

export function AssetReportHeader({
  data,
  listingType,
  reportType,
  operation,
}: {
  data: ReportDataResponse;
  listingType: number;
  reportType: number | null;
  operation: string | number;
}) {
  const intl = useIntl();
  const typology = intl
    .formatMessage({ id: `listingTypes.${listingType}` })
    .toUpperCase();
  return (
    <AssetReportHeaderStyle>
      <AssetReportHeaderLabelsContainer>
        <AssetReportHeaderTitle>
          {intl.formatMessage({ id: `valuationReport` }).toUpperCase()}
        </AssetReportHeaderTitle>
        <AssetReportHeaderTypology>{typology}</AssetReportHeaderTypology>
        <AssetReportHeaderOperation>
          {' '}
          {intl
            .formatMessage({ id: `operation.${operation ?? 1}` })
            .toUpperCase()}
        </AssetReportHeaderOperation>
      </AssetReportHeaderLabelsContainer>
      {data.logo ? (
        <div
          style={{
            width: '140px',
            height: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '10px',
          }}
        >
          <img
            src={data.logo ?? undefined}
            style={{ height: '100%' }}
            crossOrigin="anonymous"
          />
        </div>
      ) : (
        <AssetLogo />
      )}
    </AssetReportHeaderStyle>
  );
}
